import axios from '../../axios';
import {
   DELETE_EXTRA_LEDGER_ENTRIES,
} from '../types';
import { toast } from 'react-toastify';


export const deleteLedgerEntries = () => async (dispatch) => {
   try {
      const res = await axios.post(`/ledger/delete/extraLedgerEntries`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_EXTRA_LEDGER_ENTRIES, payload: { res } });
         // toast.success('extraLedger deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Customer. Please try again.');
   }
};
